/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import TableContext from './tableContext';

import styles from '../styles/uikitTablesTableHead.module.scss';

const TableHead = forwardRef(({ children = null, className = '', testId = '' }, ref) => (
  <TableContext.Provider value="head">
    <thead
      className={classnames(styles.element, className)}
      data-testid={testId}
      ref={ref}
    >
      {children}
    </thead>
  </TableContext.Provider>
));

TableHead.displayName = 'TableHead';

TableHead.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default TableHead;
